"use client";

export { default as NavigationManager } from "NavigationManager"